import { gray95opacity40 } from '../../../colors/gray';
export var MuiBackdrop = {
    styleOverrides: {
        root: {
            backgroundColor: gray95opacity40,
        },
    },
};
